import loadable from "@loadable/component";
import stringify from "fast-json-stable-stringify";
import { inject, observer } from "mobx-react";
import React from "react";
import type { Store } from "../../../../client/stores";
import { Remote } from "../../components/remote/Remote.component";
import type { QueryInput, SubscriptionInput } from "../../generated/webapi.g";
import { Sites_Lookup_By } from "../../generated/webapi.g";
import { getLocale } from "../../lib/locale";
import { lookup } from "../../lib/lookup";
import { getFeedContent } from "../../services/Sites";

const LegalNotice = loadable(() => import("./LegalNotice.component"));

interface LegalNoticeLoaderProps {
    store?: Store;
}

export const LegalNoticeLoader = inject("store")(
    observer(({ store }: LegalNoticeLoaderProps) => {
        if (!store) {
            return null;
        }
        const { site } = store;
        const subscription: SubscriptionInput[] = site.index.facets.map(facet => ({
            tags: ["collections/legal-warning", facet],
        }));
        const query: QueryInput = { subscription };
        const cacheKey = `legalnoticeloader-${stringify(query)}`;
        return (
            <Remote
                cacheKey={cacheKey}
                loader={() =>
                    getFeedContent({
                        lookup,
                        type: Sites_Lookup_By.Slug,
                        value: site.index.slug,
                        usage: "USAGE:feed-usecases/Legal Warning",
                        context: { "<locale>": getLocale(site) },
                    })
                }
                showLoading={false}
            >
                {({ data }) => {
                    if (!data || data.length === 0) {
                        return null;
                    }
                    return <LegalNotice data={data} />;
                }}
            </Remote>
        );
    }),
);

export default LegalNoticeLoader;
